import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import {
  Button,
  Typography,
} from 'antd';

import Header from '../../../../components/Header/Header';
import { TQ_VALIDATION } from '../../constants';

const FEEDBACK_MAX_LENGTH =
  TQ_VALIDATION.MAX_SERVICE_REQUEST_RESPONSE_FEEDBACK_LENGTH;

export interface ServiceMarkAsCompleteDescriptionViewProps {
  initialDescription: string;
  placeholder?: string;
  onDone: (description: string) => void;
  onClose: () => void;
}

const ServiceMarkAsCompleteDescriptionView: React.FC<
  ServiceMarkAsCompleteDescriptionViewProps
> = ({
  initialDescription,
  placeholder = 'What did they do that really made a difference?',
  onDone,
  onClose,
}) => {
  const [draft, setDraft] = useState(initialDescription);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Move cursor to end when opening the view (so user can continue typing at end)
  useEffect(() => {
    const id = requestAnimationFrame(() => {
      const el = textareaRef.current;
      if (!el) return;
      const len = el.value.length;
      el.focus();
      el.setSelectionRange(len, len);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  const isDoneEnabled = draft.trim().length > 0;
  const isCharCountNearLimit =
    draft.length >= FEEDBACK_MAX_LENGTH * 0.9 ||
    draft.length === FEEDBACK_MAX_LENGTH;

  const handleDone = () => {
    onDone(draft);
  };

  return (
    <div className="service-mark-as-complete page__container">
      <Header
        title=""
        handleBack={onClose}
        backType="cross"
        customTitle={
          <Typography.Title
            level={5}
            className="service-mark-as-complete__header-title">
            Describe your experience
          </Typography.Title>
        }
        actionItems={[
          <Button
            key="done"
            type="primary"
            htmlType="button"
            className="service-mark-as-complete__header-done"
            disabled={!isDoneEnabled}
            onClick={handleDone}>
            Done
          </Button>,
        ]}
      />
      <div className="page__content__scroll service-mark-as-complete__scroll service-mark-as-complete__description-view">
        <textarea
          ref={textareaRef}
          className="service-mark-as-complete__feedback-input service-mark-as-complete__feedback-input--full"
          placeholder={placeholder}
          value={draft}
          onChange={(e) =>
            setDraft(e.target.value.slice(0, FEEDBACK_MAX_LENGTH))
          }
          maxLength={FEEDBACK_MAX_LENGTH}
          rows={8}
        />
        <Typography.Text
          type="secondary"
          className={`service-mark-as-complete__char-count ${
            isCharCountNearLimit
              ? 'service-mark-as-complete__char-count--near-limit'
              : ''
          }`}>
          <span className="service-mark-as-complete__char-count-num">
            {draft.length}
          </span>
          /{FEEDBACK_MAX_LENGTH}
        </Typography.Text>
      </div>
    </div>
  );
};

export default ServiceMarkAsCompleteDescriptionView;
